import createSafeContext from '#/utils/createSafeContext';

import type { UDFCompatibleDatafeed } from '#/features/tradingview/datafeeds/udf/udf-compatible-datafeed';

export const [useDatafeed, DatafeedProvider] =
  createSafeContext<UDFCompatibleDatafeed>('Datafeed');
